import { Component, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastNotificationService } from '../notification/toast-notification.service';
import { closeModalOnEscape } from '../modal-dialog/modal-dialog.helper';
import { Subject } from 'rxjs';
import { filter, take, withLatestFrom } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../model/reducer';
import { Login } from '../user';
import { NavigationService } from '../navbar/navigation.service';

@Component({
    selector: 'adm4-change-password',
    template: `
		<adm4-modal-dialog-title header='Change Password' [showClose]='true' (closeClicked)="onCloseClicked()">
			<adm4-change-password-dialog
              [username]="username"
              (cancelClicked)='onCloseClicked()'
              (passwordChanged)='onChangePassword($event)'>
			</adm4-change-password-dialog>
		</adm4-modal-dialog-title>
  `,
    standalone: false
})
export class ChangePasswordComponent implements OnDestroy {
  private dialogRef = inject<MatDialogRef<ChangePasswordComponent>>(MatDialogRef);
  private toastService = inject(ToastNotificationService);
  private navigationService = inject(NavigationService);
  private store$ = inject<Store<AppState>>(Store);
  private dialogData = inject<{
    username?: string;
}>(MAT_DIALOG_DATA, { optional: true });


  readonly username: string | undefined;

  private destroyed$: Subject<boolean> = new Subject();

  constructor() {
    const dialogData = this.dialogData;


    this.username = dialogData?.username;
    closeModalOnEscape(this.dialogRef, this.destroyed$);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  onChangePassword(newPassword?: string): void {
    this.dialogRef.close();
    if (this.username && newPassword) {
      this.store$.dispatch(new Login({username: this.username, password: newPassword}));
      this.store$.select(appState => appState.userState.loaded).pipe(
        filter(loaded => loaded),
        take(1),
        withLatestFrom(this.store$.select(appState => appState.userState.authenticated)),
      ).subscribe(([, authenticated]) => {
        if (authenticated) {
          this.navigationService.navigateToReturnUrl();
        }
      });
    } else {
      this.toastService.showSuccessToast('The new password has been saved.', 'Password change successful');
    }
  }

  onCloseClicked() {
    this.dialogRef.close();
  }
}
